import { useEffect } from 'react';
import { drawViewportGrid } from '../../utils/drawViewportGrid';

/**
 * GridOverlay - Renders a grid on the Fabric.js lower-canvas using the
 * `before:render` event hook. The grid is drawn before objects and the
 * background, so it appears behind all garden elements.
 *
 * Draws directly on the Fabric.js rendering context — no separate DOM element.
 * The parent Fabric.js Canvas must NOT have `backgroundColor` set; the white
 * background is provided by CSS (`background-color: #fff` on the canvas element).
 *
 * @param {Object}            props
 * @param {fabric.Canvas}     props.canvas      - Fabric.js Canvas instance
 * @param {boolean}           props.gridEnabled - Whether the grid is visible
 * @param {number}            props.gridSize    - Grid cell size in canvas units
 * @param {string}            props.gridColor   - CSS color string for grid lines
 * @param {number}            props.gridOpacity - Opacity [0–1] for grid lines
 */
const GridOverlay = ({ canvas, gridEnabled, gridSize, gridColor, gridOpacity }) => {
  useEffect(() => {
    if (!canvas) return;

    const drawGrid = ({ ctx }) => {
      if (!gridEnabled) return;
      drawViewportGrid(ctx, canvas, { gridSize, gridColor, gridOpacity });
    };

    canvas.on('before:render', drawGrid);
    // Trigger an immediate redraw so the grid appears without waiting for
    // the next user-driven render event.
    canvas.requestRenderAll();

    return () => {
      canvas.off('before:render', drawGrid);
    };
  }, [canvas, gridEnabled, gridSize, gridColor, gridOpacity]);

  return null;
};

export default GridOverlay;
